import React from 'react';
import HeaderLayout from '../../../Layout/HeaderLayout';
import { Navigate } from 'react-router-dom';
import { IState, actions } from '../../../Store/reducer';
import creatures from '../../../Services/creatures';
import { episodes } from '../../../Services/episodes';
import ICreature from '../../../Models/ICreature';
import { DialogBoxCreature } from '../../../Components/DialogBoxCreature/DialogBoxCreature';
import { connect } from 'react-redux';
import { TNbPlayers } from '../../../Models/TNbPlayers';
import { EPISODE_MASTER_PATH } from '../../../Services/routeNames';
import Creature from '../../../Components/Creature/Creature';
import "./creatureMaster.scss";

interface ICreatureMasterProps {
    setCreaturesOnBoard: (creatures: { id: string, currentHp: number }[]) => void;
    sceneNumber: number,
    episodeNumber: number,
    creaturesOnBoard: { id: string, currentHp: number }[],
    numberOfPlayers: TNbPlayers,
}

interface ICreatureMasterState {
    availableCreature: ICreature[];
    showDialogBox: boolean;
    redirectToMj: boolean;
}

class CreatureMaster extends React.Component<ICreatureMasterProps, ICreatureMasterState> {

    constructor(props: ICreatureMasterProps) {
        super(props);
        this.state = {
            availableCreature: this.getAvailableCreatures(),
            showDialogBox: false,
            redirectToMj: false
        };
    }

    updateCreatureOnBoard() {
        let idsCreature = episodes[this.props.episodeNumber].scene[this.props.sceneNumber].creatures.engaged

        let arrayOfCreaturesOnBoard: { id: string, currentHp: number }[] = [];
        for (const id of idsCreature) {
            arrayOfCreaturesOnBoard.push({ id: id, currentHp: creatures[id].hp[this.props.numberOfPlayers] });
        }
        this.props.setCreaturesOnBoard(arrayOfCreaturesOnBoard);
    }

    componentDidMount() {
        if (!this.props.episodeNumber || !episodes[this.props.episodeNumber] || !episodes[this.props.episodeNumber].scene[this.props.sceneNumber] || this.props.numberOfPlayers < 2 || this.props.numberOfPlayers > 6) {
            this.setState({ redirectToMj: true });
        } else {
            if (this.props.creaturesOnBoard.length === 0) {
                this.updateCreatureOnBoard();
            }
        }
    }

    componentDidUpdate(prevProps: Readonly<ICreatureMasterProps>, prevState: Readonly<ICreatureMasterState>) {
        if (prevProps.sceneNumber !== this.props.sceneNumber) {
            this.updateCreatureOnBoard();
            this.setState({
                availableCreature: this.getAvailableCreatures(),
                showDialogBox: false
            });
        }
    }

    componentWillUnmount() { }

    getAvailableCreatures(): ICreature[] {
        if (episodes[this.props.episodeNumber] && episodes[this.props.episodeNumber].scene[this.props.sceneNumber] && this.props.numberOfPlayers >= 2 && this.props.numberOfPlayers <= 6) {
            return episodes[this.props.episodeNumber].scene[this.props.sceneNumber].creatures.available
                .map(id => creatures[id]);
        }

        return [];
    }

    deleteCreature(index: number) {
        this.props.setCreaturesOnBoard(this.props.creaturesOnBoard.filter((_, _index) => _index !== index))
    }

    duplicateCreature(index: number) {
        this.props.setCreaturesOnBoard(
            [...this.props.creaturesOnBoard, {
                id: this.props.creaturesOnBoard[index].id,
                currentHp: creatures[this.props.creaturesOnBoard[index].id].hp[this.props.numberOfPlayers]
            }]
        );
    }

    addCreature(index: number) {
        let id = episodes[this.props.episodeNumber].scene[this.props.sceneNumber].creatures.available[index];
        let currentHp = creatures[id].hp[this.props.numberOfPlayers];

        this.props.setCreaturesOnBoard([...this.props.creaturesOnBoard, { id, currentHp }])
    }

    render() {
        if (this.state.redirectToMj) {
            return <Navigate to={EPISODE_MASTER_PATH} />;
        } else {
            return (
                <div className="creature-container">

                    <HeaderLayout currentPage="creatures" hamburger={true} isMaster={true}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.98 100"><g><path fill="#fff" d="m94.98,20v10c0,1.02-.62,1.94-1.57,2.32l-20.92,8.37v16.8h20c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5h-20v12.5c0,.79-.05,1.56-.12,2.33l11.37,15.16h8.75c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5h-10c-.79,0-1.53-.37-2-1l-9.59-12.79c-2.34,6.44-7.24,11.62-13.54,14.31-6.3,2.69-13.43,2.66-19.7-.1-6.27-2.76-11.12-7.99-13.39-14.45l-9.77,13.02c-.47.63-1.21,1-2,1H2.5c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h8.75l11.54-15.38c-.16-1.06-.26-2.12-.29-3.19v-11.42H2.5C1.12,62.49,0,61.37,0,59.99s1.12-2.5,2.5-2.5h20v-16.8L1.57,32.32C.62,31.94,0,31.02,0,29.99v-10C0,18.62,1.12,17.5,2.5,17.5s2.5,1.12,2.5,2.5v8.31l18.5,7.4h0c.81-1.7,2.08-3.15,3.67-4.16,1.59-1.01,3.44-1.55,5.32-1.55h29.99c1.89,0,3.73.54,5.33,1.55,1.59,1.01,2.87,2.45,3.67,4.16l18.5-7.4v-8.31c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5h0Zm-32.49-5c0-5.36-2.86-10.31-7.5-12.99-4.64-2.68-10.36-2.68-15,0-4.64,2.68-7.5,7.63-7.5,12.99v7.5h29.99v-7.5Z" /></g></svg>
                        <span>Créatures</span>
                    </HeaderLayout>

                    <div className="creature-list">
                        {this.props.creaturesOnBoard.map((creature, index: number) => (
                            <Creature
                                key={index}
                                index={index}
                                creature={creature}
                                deleteCreature={() => this.deleteCreature(index)}
                                duplicateCreature={() => this.duplicateCreature(index)}
                            />
                        ))}

                        {this.props.creaturesOnBoard.length === 0 && <p className="empty-list">Cliquez sur le bouton ci-dessous pour ajoutez une créature à la scène.</p>}

                        <div className="add-creature" onClick={() => this.setState({ showDialogBox: !this.state.showDialogBox })}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 183.6"><g><path fill="#ec672a" d="m139.75,88.27c0-2.03-1.65-3.68-3.68-3.68h-15.87v7.35h15.87c2.03,0,3.68-1.65,3.68-3.68Z" /><path fill="#ec672a" d="m91.94,22.07c0-7.88-4.21-15.17-11.03-19.11-6.83-3.94-15.24-3.94-22.07,0-6.83,3.94-11.03,11.23-11.03,19.11v11.03h44.13v-11.03Z" /><path fill="#ec672a" d="m63.33,141.6c-6.13,0-11.12-4.99-11.12-11.12s4.99-11.12,11.12-11.12h33.84v-35.23c0-5.65,4.1-10.36,9.48-11.32v-12.94l30.79-12.31c1.4-.56,2.31-1.91,2.31-3.42v-14.71h0c0-2.03-1.65-3.68-3.68-3.68s-3.68,1.65-3.68,3.68v12.22l-27.21,10.89c-1.19-2.51-3.06-4.63-5.4-6.11s-5.06-2.28-7.84-2.28h-44.13c-2.77,0-5.49.8-7.83,2.28-2.34,1.49-4.22,3.61-5.4,6.11h0s-27.22-10.89-27.22-10.89v-12.22c0-2.03-1.65-3.68-3.68-3.68S0,27.39,0,29.42v14.71c0,1.5.92,2.86,2.31,3.42l30.79,12.31v24.72H3.68c-2.03,0-3.68,1.65-3.68,3.68s1.65,3.68,3.68,3.68h29.42v16.81c.05,1.57.19,3.14.42,4.69l-16.97,22.63H3.68c-2.03,0-3.68,1.65-3.68,3.68s1.65,3.68,3.68,3.68h14.71c1.16,0,2.25-.55,2.94-1.47l14.37-19.16c3.34,9.51,10.48,17.2,19.7,21.26,9.23,4.06,19.72,4.11,28.99.15,1.74-.74,3.41-1.62,4.99-2.61h-26.05Z" /><path fill="#ec672a" d="m115.05,84.13v40.38h38.98c3.3,0,5.97,2.67,5.97,5.97h0c0,3.3-2.67,5.97-5.97,5.97h-38.98v40.78c0,3.52-2.85,6.37-6.37,6.37h0c-3.52,0-6.37-2.85-6.37-6.37v-40.78h-38.99c-3.3,0-5.97-2.67-5.97-5.97h0c0-3.3,2.67-5.97,5.97-5.97h38.99v-40.38c0-3.52,2.85-6.37,6.37-6.37h0c3.52,0,6.37,2.85,6.37,6.37Z" /></g></svg>
                        </div>

                        {this.state.showDialogBox &&
                            <DialogBoxCreature
                                creaturesAvailable={this.state.availableCreature}
                                onClose={() => this.setState({ showDialogBox: !this.state.showDialogBox })}
                                onValidate={(index: number) => this.addCreature(index)}
                            />
                        }
                    </div>

                </div >
            );
        }
    }
}

const mapStateToProps = (state: IState) => ({
    sceneNumber: state.master.sceneNumber,
    episodeNumber: state.master.episodeNumber,
    creaturesOnBoard: state.master.creaturesOnBoard,
    numberOfPlayers: state.master.numberOfPlayers,
});

const mapDispatchToProps = (dispatch: any) => ({
    setCreaturesOnBoard: (tabCreatures: { id: string, currentHp: number }[]) => {
        dispatch({
            type: actions.master.SET_CREATURES,
            payload: {
                master: { creaturesOnBoard: tabCreatures }
            }
        })
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatureMaster);